import { LogLevel } from '../consts';
import { shouldLog } from '../utils';

export abstract class Transport {
  private level: LogLevel;

  constructor({ level = 'debug' }: { level?: LogLevel } = {}) {
    this.level = level;
  }

  abstract log(
    name: string,
    level: LogLevel,
    message: string,
    ...args: unknown[]
  ): void;

  shouldLog(level: LogLevel): boolean {
    return shouldLog(level, this.level);
  }
}
